$(document).ready(function () {
    $('.nav-sidebar__level-1 > li.nav-sidebar__item > span').on(
        'click',
        function (e) {
            e.preventDefault()
            e.stopPropagation()
            e.stopImmediatePropagation()

            $(this).next('.nav-sidebar__level-2').show()
            $('.nav-sidebar__wrapper')
                .removeClass('nav-sidebar__wrapper--level-1')
                .addClass('nav-sidebar__wrapper--level-2')
        }
    )

    $('.nav-sidebar__level-2 > li.nav-sidebar__item > span').on(
        'click',
        function (e) {
            e.preventDefault()
            e.stopPropagation()
            e.stopImmediatePropagation()

            $(this).next('.nav-sidebar__level-3').show()
            $('.nav-sidebar__wrapper')
                .removeClass('nav-sidebar__wrapper--level-2')
                .addClass('nav-sidebar__wrapper--level-3')
        }
    )

    $('.nav-sidebar__back-to-1').on('click', function () {
        $(this).parent().fadeOut(300)
        $('.nav-sidebar__wrapper')
            .removeClass('nav-sidebar__wrapper--level-2')
            .addClass('nav-sidebar__wrapper--level-1')
    })

    $('.nav-sidebar__back-to-2').on('click', function () {
        $(this).parent().fadeOut(300)
        $('.nav-sidebar__wrapper')
            .removeClass('nav-sidebar__wrapper--level-3')
            .addClass('nav-sidebar__wrapper--level-2')
    })

    $('.nav__trigger').on('click', function () {
        $('.nav-sidebar').addClass('nav-sidebar--is-active')
        $('.overlay').fadeIn(300)
        $('body').css('overflow', 'hidden')
    })

    $('.nav-sidebar__close, .overlay').on('click', function () {
        $('.nav-sidebar').removeClass('nav-sidebar--is-active')
        $('.overlay').fadeOut(300)
        $('body').css('overflow', 'auto')
    })
})
